import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useLayoutEffect, useRef, useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Tooltip,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getUserList, deleteUser } from 'src/redux/slices/user';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths' ;
// components
import Page from 'src/components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from 'src/components/Label';
import SearchNotFound from 'src/components/SearchNotFound';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list';
import UserListHeadTwo from 'src/components/_dashboard/user/list/UserListHeadtwo';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';
import  ProductToolbar  from 'src/components/_dashboard/user/list/ProductToolbar.js';
import  ProductsSearch  from 'src/components/_dashboard/blog/ProductsSearch.js';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {COMPANY_NAME, REST_API, REST_API_END_POINT, UNITS} from 'src/constants/Defaultvalues';
import moment from 'moment';
import MaterialInventoryMenu from 'src/components/_dashboard/user/list/MaterialInventoryMenu';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import InventoryAuditPage from './InventoryAuditPage';
import { ArrowBackIos, ArrowForwardIos, QrCodeScanner } from '@material-ui/icons';
import { Html5QrcodeScanner } from 'html5-qrcode';

// ----------------------------------------------------------------------

const TABLE_HEAD = [

  { id: 'name', label: 'Name', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'unit', label: 'Unit', alignRight: false },
  // { id: 'total_qty', label: 'Stock', alignRight: false },
  { id: 'finishedProductQty', label: 'Finished Stock', tooltip: 'Finished Stock', alignRight: false },
  { id: 'partialProductQty', label: 'Partial Stock', tooltip: 'Partial Stock', alignRight: false },
  { id: 'min_value', label: 'Min Value', alignRight: false },
  { id: 'max_value', label: 'Max Value', alignRight: false },
  // { id: 'addedby', label: 'Added By', alignRight: false },
  // { id: 'addedon', label: 'Added On', alignRight: false },
//   { id: 'status', label: 'Status', alignRight: false },
  { id:'options', label: '', alignRight: false},      
  { id:'', label: '', alignRight: false},      
];

// ----------------------------------------------------------------------

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }
function descendingComparator(a, b, orderBy) {
  const aValue = a[orderBy] ? a[orderBy].toString() : '';
  const bValue = b[orderBy] ? b[orderBy].toString() : '';
  return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  
  const sortedArray = stabilizedThis.map((el) => el[0]);
  
  if (query) {
    // return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    const normalizedQuery = query.toLowerCase().replace(/\s+/g, ' ').trim();
    return filter(sortedArray, (_user) => {
      const normalize = (str) => (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const nameMatch = normalize(_user.name).includes(normalizedQuery);
      const descriptionMatch = normalize(_user.description).includes(normalizedQuery);
      return nameMatch || descriptionMatch;
    });
  }
  // return stabilizedThis.map((el) => el[0]);
  return sortedArray;
}

function scrollInventoryAuditPaginationToTop(anchorEl, tableScrollBoxEl, tableContainerEl) {
  if (typeof window === 'undefined') return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = anchorEl
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }

  if (tableScrollBoxEl) {
    tableScrollBoxEl.scrollTop = 0
    if (typeof tableScrollBoxEl.scrollTo === 'function') {
      tableScrollBoxEl.scrollTo({
        top: 0,
        left: tableScrollBoxEl.scrollLeft,
        behavior: 'auto',
      })
    }
  }
  if (tableContainerEl) {
    const left = tableContainerEl.scrollLeft
    tableContainerEl.scrollTop = 0
    if (typeof tableContainerEl.scrollTo === 'function') {
      tableContainerEl.scrollTo({ top: 0, left, behavior: 'auto' })
    }
  }
}

export default function InventoryAuditList(props) {
  const theme = useTheme();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [ProductList, setProductList] = useState([]);
  const [total, setTotal] = useState(0);
  const location = useLocation();
  const receivedData = location.state?.data;
  const barcodeFromState = location.state?.barcode;
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const userId = userData.user_id
  const userType = userData.user_type
  const tableContainerRef = useRef(null);
  const tableScrollBoxRef = useRef(null);
  const tableMaxHeight = useTableMaxHeight(
    tableScrollBoxRef,
    [loading, ProductList?.length, rowsPerPage, page]
  );
  const paginationScrollAnchorRef = useRef(null);
  const skipPaginationScrollRef = useRef(true);
  const prevLoadingForPaginationScrollRef = useRef(loading);
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const scannerRef = useRef(null);
  const [searchMaterial, setSearchMaterial] = useState('');
  const [qrSearchDisplayName, setQrSearchDisplayName] = useState('');
  const [columnWidths, setColumnWidths] = useState({});
  const [headerOrder, setHeaderOrder] = useState([]);
  const headerOrderInitialized = useRef(false);

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const run = () =>
      scrollInventoryAuditPaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  useEffect(() => {
    const prev = prevLoadingForPaginationScrollRef.current
    prevLoadingForPaginationScrollRef.current = loading
    if (prev !== true || loading !== false) return
    const run = () =>
      scrollInventoryAuditPaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [loading])

  // Load column widths from localStorage on mount
  useEffect(() => {
    const storageKey = 'inventoryAuditList_columnWidths';
    const savedWidths = localStorage.getItem(storageKey);
    if (savedWidths) {
      try {
        setColumnWidths(JSON.parse(savedWidths));
      } catch (error) {
        console.error('Error loading column widths:', error);
      }
    } else {
      setColumnWidths({});
    }
  }, []);

  // Load header order from localStorage on mount
  useEffect(() => {
    const storageKey = 'inventoryAuditList_headerOrder';
    const savedOrder = localStorage.getItem(storageKey);
    if (savedOrder) {
      try {
        const parsedOrder = JSON.parse(savedOrder);
        if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
          setHeaderOrder(parsedOrder);
          headerOrderInitialized.current = true;
        } else {
          setHeaderOrder([]);
          headerOrderInitialized.current = false;
        }
      } catch (error) {
        console.error('Error loading header order:', error);
        setHeaderOrder([]);
        headerOrderInitialized.current = false;
      }
    } else {
      setHeaderOrder([]);
      headerOrderInitialized.current = false;
    }
  }, []);

  // Save column widths to localStorage
  const handleColumnResize = useCallback((columnId, newWidth) => {
    setColumnWidths((prev) => {
      const updated = { ...prev, [columnId]: newWidth };
      const storageKey = 'inventoryAuditList_columnWidths';
      localStorage.setItem(storageKey, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Handle header reorder
  const handleHeaderReorder = useCallback((draggedIndex, dropIndex) => {
    setHeaderOrder((prevOrder) => {
      const newOrder = [...prevOrder];
      const [removed] = newOrder.splice(draggedIndex, 1);
      newOrder.splice(dropIndex, 0, removed);
      const storageKey = 'inventoryAuditList_headerOrder';
      localStorage.setItem(storageKey, JSON.stringify(newOrder));
      return newOrder;
    });
  }, []);

  const getAllMaterial = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-materials-autit`,
        {
          userId,
          userType,
        isVendor:1,
        page: page + 1, 
        limit: rowsPerPage,
        search: filterName.trim()
      });
      const productListData = response.data.results
      if(productListData){
        let Total = response?.data?.total || 0
        setProductList(productListData);
        setTotal(Total);
      }
      else{
        setProductList([]);
      }
    }
      catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }

  useEffect( async () => {
    getAllMaterial()
  }, [receivedData,page, rowsPerPage, filterName]);

  // Handle barcode from location.state (from navbar QR scan)
  useEffect(() => {
    if (barcodeFromState) {
      setQrSearchDisplayName(barcodeFromState);
      setSearchMaterial(barcodeFromState);
      setFilterName(barcodeFromState);
      handleSearchMaterialByQR(barcodeFromState);
      // Clear the barcode from location state to prevent re-triggering
      navigate(location.pathname, {
        state: { ...location.state, barcode: null },
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barcodeFromState]);

  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData?.map((n) => n.id);
      const newSelectedNames = slicedData?.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id,name) => {
    const selectedIndex = selected?.indexOf(id);
    const selectedNameIndex = selectedNames?.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
      newselectedNames = newselectedNames?.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, selectedNameIndex), selectedNames?.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelected([]);
    setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ProductList.length) : 0;
  const filteredUsers = applySortFilter(ProductList, getComparator(order, orderBy), filterName);
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = ProductList.length === 0;

  // Function to render table cell based on header ID
  const renderTableCell = (headerId, row) => {
    // Handle empty header IDs (placeholders)
    if (!headerId || headerId === '') {
      return null;
    }

    const { id, thumbnail, name, timestamp, min_value, max_value, status, price, tax, authorized_by, total_qty, finishedProductQty, partialProductQty, isVerified, description, unit,meterial } = row;
    const unitName = UNITS.find(u => u.id === unit)?.name || 'N/A';

    switch (headerId) {
      case 'name':
        return (
          <TableCell key="name" align="left" sx={{ 
            cursor: 'pointer',
            width: columnWidths['name'] || 'auto',
            minWidth: columnWidths['name'] || 'auto',
            maxWidth: columnWidths['name'] || 'none'
          }}>
            <Tooltip title={name} arrow>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  cursor: 'pointer',
                  maxWidth: columnWidths['name'] || {xs: 300, sm: 300, md: 300, lg: 360, xl: 440},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                  fontSize: '0.75rem',
                  color: !meterial ? "#1ccaff" : null,
                }}
              >
                {name}
              </Typography>
            </Tooltip>
          </TableCell>
        );
      case 'description':
        return (
          <TableCell key="description" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['description'] || 'auto',
            minWidth: columnWidths['description'] || 'auto',
            maxWidth: columnWidths['description'] || 'none'
          }}>
            <Tooltip title={description} arrow>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  fontSize: '0.75rem',
                  maxWidth: columnWidths['description'] || {xs: 300, sm: 300, md: 300, lg: 360, xl: 440},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {description}
              </Typography>
            </Tooltip>
          </TableCell>
        );
      case 'unit':
        return (
          <TableCell key="unit" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['unit'] || 'auto',
            minWidth: columnWidths['unit'] || 'auto',
            maxWidth: columnWidths['unit'] || 'none'
          }}>
            <Tooltip title={unitName} arrow>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  fontSize: '0.75rem',
                  maxWidth: columnWidths['unit'] || '80px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {unitName}
              </Typography>
            </Tooltip>
          </TableCell>
        );
      case 'finishedProductQty':
        return (
          <TableCell key="finishedProductQty" align="left" sx={{ 
            fontSize: '0.75rem', 
            color: (finishedProductQty <= 0) ? theme.palette.error.main : null,
            width: columnWidths['finishedProductQty'] || 'auto',
            minWidth: columnWidths['finishedProductQty'] || 'auto',
            maxWidth: columnWidths['finishedProductQty'] || 'none'
          }}>
            {finishedProductQty}
          </TableCell>
        );
      case 'partialProductQty':
        return (
          <TableCell key="partialProductQty" align="left" sx={{ 
            fontSize: '0.75rem', 
            color: (partialProductQty <= 0) ? theme.palette.error.main : null,
            width: columnWidths['partialProductQty'] || 'auto',
            minWidth: columnWidths['partialProductQty'] || 'auto',
            maxWidth: columnWidths['partialProductQty'] || 'none'
          }}>
            {partialProductQty}
          </TableCell>
        );
      case 'min_value':
        return (
          <TableCell key="min_value" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['min_value'] || 'auto',
            minWidth: columnWidths['min_value'] || 'auto',
            maxWidth: columnWidths['min_value'] || 'none'
          }}>
            {min_value}
          </TableCell>
        );
      case 'max_value':
        return (
          <TableCell key="max_value" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['max_value'] || 'auto',
            minWidth: columnWidths['max_value'] || 'auto',
            maxWidth: columnWidths['max_value'] || 'none'
          }}>
            {max_value}
          </TableCell>
        );
      case 'options':
        return (
          <TableCell key="options" align="left" sx={{
            width: columnWidths['options'] || 'auto',
            minWidth: columnWidths['options'] || 'auto',
            maxWidth: columnWidths['options'] || 'none'
          }}>
            <Button 
              disabled={explodedPermissions?.some(permission => ['Inventory Audit'].includes(permission)) ? false : true}
              variant='contained' 
              component={RouterLink} 
              to={`${PATH_DASHBOARD.inventoryAudit.auditPage}?id=${id}`}
              size="small"
              sx={{ 
                fontSize: '0.75rem',
                padding: '2px 12px',
                minWidth: 'auto'
              }}
            > 
              Audit 
            </Button>
          </TableCell>
        );
      default:
        return null;
    }
  };

  const dynamicTableHead = (() => {
    const baseHead = [...TABLE_HEAD];

    // Filter out empty headers for reordering (they stay in fixed positions)
    const reorderableHeaders = baseHead.filter(h => h.id && h.id !== '');

    // Check localStorage directly if headerOrder state is empty (during initial load)
    let orderToUse = headerOrder;
    if (headerOrder.length === 0) {
      const storageKey = 'inventoryAuditList_headerOrder';
      const savedOrder = localStorage.getItem(storageKey);
      if (savedOrder) {
        try {
          const parsedOrder = JSON.parse(savedOrder);
          if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
            orderToUse = parsedOrder;
            // Update state asynchronously to avoid render issues
            if (!headerOrderInitialized.current) {
              setTimeout(() => {
                setHeaderOrder(parsedOrder);
                headerOrderInitialized.current = true;
              }, 0);
            }
          }
        } catch (error) {
          console.error('Error parsing saved header order:', error);
        }
      }
    }

    // Apply header order if available
    if (orderToUse.length > 0) {
      const orderedHead = [];
      const reorderableMap = new Map(reorderableHeaders.map(h => [h.id, h]));
      
      // Reorder based on saved order, preserving only headers that exist
      orderToUse.forEach((id) => {
        const header = reorderableMap.get(id);
        if (header) {
          orderedHead.push(header);
          reorderableMap.delete(id);
        }
      });
      
      // Add any remaining headers that weren't in the saved order (new headers)
      reorderableMap.forEach((header) => {
        orderedHead.push(header);
      });
      
      // Update header order if structure changed (new headers added)
      const currentOrder = orderedHead.map(h => h.id);
      if (currentOrder.length !== orderToUse.length) {
        const storageKey = 'inventoryAuditList_headerOrder';
        localStorage.setItem(storageKey, JSON.stringify(currentOrder));
        if (headerOrder.length > 0) {
          setHeaderOrder(currentOrder);
        }
      }
      
      return orderedHead;
    }

    // Initialize header order on first load (when headerOrder is empty and not yet initialized)
    if (orderToUse.length === 0 && reorderableHeaders.length > 0 && !headerOrderInitialized.current) {
      const initialOrder = reorderableHeaders.map(h => h.id);
      const storageKey = 'inventoryAuditList_headerOrder';
      localStorage.setItem(storageKey, JSON.stringify(initialOrder));
      headerOrderInitialized.current = true;
      setHeaderOrder(initialOrder);
    }
    return baseHead;
  })();


  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              setSearchMaterial(decodedText);
              handleSearchMaterialByQR(decodedText); // renamed function
              setOpenQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner]);

  const handleSearchMaterialByQR = async (materialBarcode) => {
    try {
      if (!materialBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: materialBarcode,
        userId,
        userType,
        isMaterial: true
      });

      if (response.data.status === 1) {
        const productListData = response.data.results;
        setProductList(productListData);
        setTotal(productListData.length); // or response.data.total if paginated
        setQrSearchDisplayName(materialBarcode || '');
      } else {
        setProductList([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error searching material by QR:", error);
    }
  };

  return (
    <Page title={`Inventory Audit : List | ${COMPANY_NAME}`}>
      <Container>
        <Card>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <MaterialInventoryToolbar 
          numSelected={selected?.length} 
          filterName={filterName} 
          onFilterName={handleFilterByName} 
          selectedName={selectedNames} 
          selected={selected} 
          openQRScanner={openQRScanner}
          setOpenQRScanner={setOpenQRScanner}
          onDelete={() => {setSelected([]);setPage(0);}}
          item="Inventory"
          qrSearched={!!(searchMaterial || filterName)}
          qrShow={true}
          onClearQRSearch={() => {
            setSearchMaterial('');
            setFilterName('');
            setQrSearchDisplayName('');
            setPage(0);
          }}
          qrSearchValue={qrSearchDisplayName}
          />

          {/* <IconButton onClick={() => setOpenQRScanner(true)}>
            <QrCodeScanner sx={{ fontSize: "30px" }} />
          </IconButton>
          <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
            <DialogTitle>Scan QR Code</DialogTitle>
            <DialogContent>
              <div id="reader" style={{ width: "100%" }}></div>
            </DialogContent>
          </Dialog> */}

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mr: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff', borderRadius: '20%', border: '1px solid black' }} />
              <Typography variant="body2">Material</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 20, height: 20, backgroundColor: '#1ccaff', borderRadius: '20%', border: '1px solid black' }} />
              <Typography variant="body2">Catalog</Typography>
            </Box>
          </Box>

          </Box>
          <Box ref={paginationScrollAnchorRef}>
          <Box
            ref={tableScrollBoxRef}
            sx={{
              maxHeight: tableMaxHeight,
              overflowY: 'auto',
              overflowX: 'hidden',
              width: '100%',
              '&::-webkit-scrollbar': {
                width: '0.6em',
                height: '0.6em',
              },
              '&::-webkit-scrollbar-track': {
                background: '#1e1e1e',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#555',
                borderRadius: '6px',
                border: '2px solid #1e1e1e',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#888',
              },
              '&::-webkit-scrollbar-corner': {
                backgroundColor: '#1e1e1e',
              },
            }}
          >
            <TableContainer
              ref={tableContainerRef}
              sx={{
                minWidth: 800,
                whiteSpace: 'nowrap',
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  width: '0.6em',
                  height: '0.6em',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#1e1e1e',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#555',
                  borderRadius: '6px',
                  border: '2px solid #1e1e1e',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#888',
                },
                '&::-webkit-scrollbar-corner': {
                  backgroundColor: '#1e1e1e',
                },
              }}
            >
              <Table 
                stickyHeader
                sx={{
                  '& .MuiTableCell-head': {
                    padding: '8px 12px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    height: '48px',
                    minHeight: '48px',
                    maxHeight: '48px',
                    lineHeight: 1.4,
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                  },
                  '& .MuiTableSortLabel-root': {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    justifyContent: 'flex-start',
                    '& .MuiTableSortLabel-icon': {
                      marginLeft: '4px'
                    }
                  }
                }}
              >
              <UserListHeadTwo
                  order={order}
                  orderBy={orderBy}
                  headLabel={dynamicTableHead}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  showAllCheckBox={false}
                  columnWidths={columnWidths}
                  onColumnResize={handleColumnResize}
                  showSeparators={true}
                  onHeaderReorder={handleHeaderReorder}
                />
                <TableBody>
                {loading ? (
                      <LoadingScreen
                        sx={{ top: 0,
                              left: 0,
                              width: 1,
                              zIndex: 9999,
                              position: 'fixed',
                              }}
                      />
                    ) : (
                      <>                  
                  {ProductList?.map((row) => {
                    let { id,thumbnail, name, timestamp,min_value,max_value, status, price,tax, authorized_by,total_qty,finishedProductQty,partialProductQty, isVerified,description,unit } = row;
                    let statusText;
                    (status === 1) ? statusText = "Active" : statusText = "Inactive";
                    let image = `${REST_API}build/images/products/${thumbnail}`;
                    let addedon = moment.unix(timestamp).format('MM/DD/YYYY');
                    const isItemSelected = selected?.indexOf(id) !== -1;
                                    
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        sx={{
                          '& .MuiTableCell-root': {
                            padding: '8px 12px',
                            fontSize: '0.75rem',
                            height: 'auto',
                            lineHeight: 1.4
                          }
                        }}
                      >
                        <TableCell padding="checkbox" align="left" onClick={handleScrollRight} sx={{ padding: '8px 4px !important', width: '40px' }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                            <ArrowForwardIos color="#ffffff" sx={{ width: "16px", fontSize: '0.875rem' }}/>
                          </IconButton>
                        </TableCell>

                        {/* Render cells based on dynamicTableHead order */}
                        {dynamicTableHead.map((header) => {
                          const cell = renderTableCell(header.id, row);
                          return cell;
                        })}

                        <TableCell padding="checkbox" align="left" onClick={handleScrollLeft} sx={{ padding: '8px 4px !important', width: '40px' }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                            <ArrowBackIos color="#ffffff" sx={{ width: "16px", ml: 0.5, fontSize: '0.875rem' }}/>
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                  </>
                    )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Inventory items"/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>

          <TablePagination
            // rowsPerPageOptions={[5, 10, 25]}
            rowsPerPageOptions={[25, 50, 100, 500]}

            component="div"
            count={total || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
